<template>
  <div class="mobile-approval-list">
    <div class="nav-bar">
      <i @click="handleBack" class="el-icon-arrow-left">返回</i>
      <span>审批列表</span>
      <span style="padding: 0 22px">&nbsp;</span>
    </div>
    <el-radio-group
      class="button-group"
      type="border-card"
      v-model="searchData.status"
      @change="handleClick"
    >
      <el-radio-button label="2">待审批</el-radio-button>
      <el-radio-button label="3">已审批</el-radio-button>
      <el-radio-button label="1">我的发起</el-radio-button>
    </el-radio-group>
    <ul class="common-line title-line">
      <li class="one">序号</li>
      <li class="two">任务名称</li>
      <li class="three">申报单位</li>
      <li class="four">申报状态</li>
    </ul>
    <div
      style="max-height: calc(100vh - 138px);overflow: auto;"
      v-if="dataList.length"
      v-loading="loadingTable"
    >
      <ul
        v-for="(item, index) in dataList"
        class="common-line content-line"
        @click="handleApproval(item)"
      >
        <li class="one">{{index+1}}</li>
        <li class="two">
          <div class="word-lots">{{item.applyName}}</div>
        </li>
        <li class="three">
          <div class="word-lots">{{item.applyCompanyName}}</div>
        </li>
        <li class="four">
          <el-tag @click="handleApproval(item)" v-if="item.applyStatus == 1">已创建</el-tag>
          <el-tag
            @click="handleApproval(item)"
            v-if="item.applyStatus == 2"
            style="color: #00a585"
          >已上报</el-tag>
          <el-tag @click="handleApproval(item)" v-if="item.applyStatus == 3" type="info">待审批</el-tag>
          <el-tag @click="handleApproval(item)" v-if="item.applyStatus == 4" type="warning">回退修改</el-tag>
          <el-tag @click="handleApproval(item)" v-if="item.applyStatus == 5" type="info">审批中</el-tag>
          <el-tag @click="handleApproval(item)" v-if="item.applyStatus == 6" type="success">审批通过</el-tag>
          <el-tag @click="handleApproval(item)" v-if="item.applyStatus == 7" type="danger">审批失败</el-tag>
          <el-tag @click="handleApproval(item)" v-if="item.applyStatus == 8">已申请函件</el-tag>
          <el-tag
            @click="handleApproval(item)"
            v-if="item.applyStatus == 9"
            style="color: #00a585"
          >已签章</el-tag>
          <i class="el-icon-arrow-right arrow"></i>
        </li>
      </ul>
      <div
        class="no-data load-more"
        @click="loadMore"
        v-if="currentPage < Math.ceil(total/pageSize)"
      >点击加载更多>></div>
      <div
        class="no-data"
        style="line-height: 30px"
        @click="loadMore"
        v-if="currentPage >= Math.ceil(total/pageSize) && dataList.length > 12"
      >已经到底了</div>
    </div>
    <div v-if="!dataList.length" class="no-data" style="color: #ccc">
      <span>暂无数据</span>
    </div>
    <div style="text-align: center">
    <span>版权所有：中国化学工程集团(股份)有限公司 | <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17025820号-5</a> | 版本号：{{this.versionNumber}}<!-- | 技术支持：北京赛鼎科技有限公司 --></span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ApprovalApi from "../../api/foreign/foreign_Invitation_manage/InvitationApprovalApi.js";
import encipherUtil from "@/util/encipher";
let encipher = new encipherUtil()
export default {
  name: "mobile-approval-list",
  computed: {
    ...mapGetters(["account", "versionNumber"])
  },
  data() {
    return {
      searchData: {
        applyName: "", //任务名称
        inviNo: "", //收文编号
        status: "2", //审批状态
        applyCompanyName: "" //申报单位
      },
      loadingTable: false,
      dataList: [],
      pageSize: 12,
      total: 0,
      currentPage: 1,
      isLoad: false
    };
  },
  //判断是否由详情页面返回
  beforeRouteEnter(to, from, next) {
    if (from.path !== "/mobile-approval") {
      sessionStorage.removeItem("approvalType");
    }
    next();
  },
  methods: {
    //切换列表标签
    handleClick() {
      this.currentPage = 1;
      this.dataList = [];
      this.getDataList();
    },
    loadMore(val) {
      this.currentPage++;
      // 获取审批列表
      this.getDataList();
    },
    //审批
    handleApproval(item) {
      if (item.param) {
        //status为3对应pc端已审批页面 type参数值传detail 与pc端同步
        let type = this.searchData.status === '3' ? 'detail' : ''
        this.$router.push({
          path: "/mobile-approval-setup?" + item.param + "&type=" + type
        });
      } else {
        if (item.type == 3 || item.type == 4) {
          this.$router.push({
            path: "/mobile-approval-document",
            query: { id: item.inviApplyId, type: item.type, isDetail: this.searchData.status==="3"?1:0 }
          });
        } else {
          encipher.setSessionStorageAES("approvalType", this.searchData.status);
          //跳转到审批页面
          let type = '';
          if(this.searchData.status == '1'){
            type = '3';
          }else{
            type = item.type;
          }
          this.$router.push({
            path: "/mobile-approval?id=" + item.inviApplyId + "&type=" + type
          });
        }
      }
    },
    //返回
    handleBack(item) {
      //跳转到审批页面
      this.$router.back();
    },
    // 获取审批列表
    getDataList() {
      let http = new ApprovalApi();
      this.searchData.pageSize = this.pageSize;
      this.searchData.pageNo = this.currentPage;
      this.loadingTable = true;
      if (this.searchData.status === "1") {
        http
          .getLaunchList({
            ...this.searchData,
            accountId: this.account.accountId
          })
          .then(res => {
            let list = [];
            this.currentPage = Number(res.data.current);;
            if(this.currentPage > 1){
              list = res.data.records;
              list.forEach((item) => {
                this.dataList.push(item)
              })
            }else{
              this.dataList = res.data.records;
            };
            this.total = Number(res.data.total);
            this.loadingTable = false;
          })
          .catch(err => {
            this.loadingTable = false;
          });
      } else {
        http
          .getApprovalList({
            ...this.searchData,
            accountId: this.account.accountId
          })
          .then(res => {
            let list = [];
            this.currentPage = Number(res.data.current);;
            if(this.currentPage > 1){
              list = res.data.records;
              list.forEach((item) => {
                this.dataList.push(item)
              })
            }else{
              this.dataList = res.data.records;
            }
            this.total = Number(res.data.total);
            this.loadingTable = false;
          })
          .catch(err => {
            this.loadingTable = false;
          });
      }
    }
  },
  mounted() {
    this.searchData.status = encipher.getSessionStorageAES("approvalType") || "2";
    // 获取审批列表
    this.getDataList();
  }
};
</script>
<style lang="scss" scoped>
@function vw($p) {
  @return $p/750 * 100 + vw;
}
$light-blue: #0270c1;
.mobile-approval-list {
  padding: 10px;
  height: calc(100vh - 20px);
  .button-group {
    margin-bottom: 10px;
    /deep/ .el-radio-button__inner {
      width: calc(33.3vw - 7px);
    }
  }
  .nav-bar {
    height: 36px;
    line-height: 30px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // i {
    //   font-weight: 400;
    // }
  }
  .no-data {
    height: 30px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    color: #aaa;
    border-top: 1px solid #999;
  }
  .load-more {
    color: $light-blue;
    line-height: 30px;
  }
  .common-line {
    display: flex;
    list-style: none;
    position: relative;
    color: #222;
    font-size: 15px;
    height: 50px;
    li {
      height: 50px;
      line-height: 50px;
      text-align: center;
      box-sizing: border-box;
      padding: 0 3px;
      border-left: 1px solid #999;
      &:first-child {
        border-left: none;
      }
    }
    .one {
      width: 38px;
    }
    .two,
    .three,
    .four {
      display: flex;
      align-items: center;
      justify-content: center;
      .word-lots {
        line-height: 21px;
        min-height: 21px;
        max-height: 42px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -moz-box-orient: vertical;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        -moz-line-clamp: 2;
        padding: 0;
        margin: 0;
      }
    }
    .two {
      width: calc(50% - 38px);
    }
    .three {
      width: calc(50% - 84px);
    }
    .four {
      width: 84px;
      padding: 0;
      .arrow {
        font-size: 16px;
        font-weight: 700;
        color: #bbb;
        margin-left: 4px;
      }
      /deep/ .el-tag--medium {
        height: auto;
        line-height: 20px;
        max-height: 42px;
        width: 62px;
        white-space: pre-wrap;
        font-size: 14px;
        padding: 0 2px;
        background: transparent;
        border: none;
      }
    }
  }
  .title-line {
    border-radius: 5px 5px 0 0;
    border: 1px solid #555;
    background: #ddd;
    height: 34px;
    padding-left: 0 !important;
    li {
      height: 34px;
      line-height: 34px;
    }
  }
  .content-line {
    line-height: 20px;
    border-left: 1px solid #555;
    border-right: 1px solid #555;
    &:last-child {
      border-radius: 0 0 5px 5px;
      border-bottom: 1px solid #555;
    }
    &:nth-child(2n + 1) {
      background: #fff;
    }
    &:nth-child(2n) {
      background: #f3f3f3;
    }
  }
}
</style>
